/**
 * Ledger Service - Re-exports from generated service
 *
 * This file wraps the auto-generated ledger service to provide:
 * - Stable import path that won't be overwritten by codegen
 * - All generated hooks and types
 *
 * After regenerating the API (pnpm generate:api), the generated service
 * should have proper types for all endpoints.
 */

import { enhancedApi as generatedApi } from './generated/ledgerService';

// Re-export all types from generated service
export type {
  AllocationBucket,
  BenefitType,
  BenefitUtilization,
  CoverageCategory,
  CoverageSummary,
  CreateAllocation,
  CreateExpense,
  CreateLien,
  ExpenseListApiArg,
  LedgerSummary,
  LedgerWarning,
  LienholderType,
  LienListApiArg,
  LienStatus,
  LienType,
  PayerType,
  ProviderBreakdown,
  ProviderSummary,
  ReadAllocation,
  ReadExpense,
  ReadLien,
  UpdateExpense,
  UpdateLien,
} from './generated/ledgerService';

// Export the API for store configuration
export const ledgerApi = generatedApi;

// Export hooks from the API
export const {
  // Expense queries
  useExpenseListQuery,
  useExpenseRetrieveQuery,

  // Expense mutations
  useExpenseCreateMutation,
  useExpenseUpdateMutation,
  useExpenseDestroyMutation,
  useExpenseReplaceAllocationsMutation,

  // Lien queries
  useLienListQuery,
  useLienRetrieveQuery,

  // Lien mutations
  useLienCreateMutation,
  useLienUpdateMutation,
  useLienDestroyMutation,

  // Ledger summary queries
  useLedgerSummaryQuery,
  useLedgerByProviderQuery,
  useLedgerExpensesNeedingReviewQuery,
} = generatedApi;

// Alias hooks for cleaner naming (optional convenience exports)
export {
  useLedgerExpensesNeedingReviewQuery as useGetExpensesNeedingReviewQuery,
  useLedgerSummaryQuery as useGetLedgerSummaryQuery,
  useLedgerByProviderQuery as useGetProviderBreakdownQuery,
  useExpenseReplaceAllocationsMutation as useReplaceExpenseAllocationsMutation,
};
